module.exports = __webpack_public_path__ + "static/media/mode-59.39742e23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-59.svg
// module id = 1013
// module chunks = 2